import { render, staticRenderFns } from "./journey-chart.vue?vue&type=template&id=84fccf40&"
import script from "./journey-chart.vue.js?vue&type=script&lang=js&"
export * from "./journey-chart.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports